import { motion } from 'framer-motion';

export const TradingCycleDiagram = () => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
      className="w-full"
      data-testid="trading-cycle-diagram"
    >
      <svg viewBox="0 0 1000 660" className="w-full h-auto" fill="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <marker id="arw" viewBox="0 0 10 7" refX="9" refY="3.5" markerWidth="8" markerHeight="6" orient="auto-start-reverse">
            <path d="M 0 0 L 10 3.5 L 0 7 z" fill="#6B7280" />
          </marker>
          <marker id="arw-g" viewBox="0 0 10 7" refX="9" refY="3.5" markerWidth="8" markerHeight="6" orient="auto-start-reverse">
            <path d="M 0 0 L 10 3.5 L 0 7 z" fill="#3ba236" />
          </marker>
          <marker id="arw-b" viewBox="0 0 10 7" refX="9" refY="3.5" markerWidth="8" markerHeight="6" orient="auto-start-reverse">
            <path d="M 0 0 L 10 3.5 L 0 7 z" fill="#a6533a" />
          </marker>
        </defs>

        {/* ═══ "banks" L-path: EARN → across top → down to BANK ═══ */}
        <path d="M 360 65 L 360 28 L 860 28 L 860 218" stroke="#3ba236" strokeWidth="2" fill="none" markerEnd="url(#arw-g)" />
        <text x="610" y="20" textAnchor="middle" fill="#3ba236" fontSize="13" fontStyle="italic" fontFamily="ui-monospace, monospace">banks</text>

        {/* ═══ MEASURE → EARN (gray arrow) ═══ */}
        <line x1="162" y1="278" x2="325" y2="155" stroke="#9CA3AF" strokeWidth="2" markerEnd="url(#arw)" />

        {/* ═══ MEASURE → BUY (gray arrow) ═══ */}
        <line x1="162" y1="322" x2="325" y2="425" stroke="#9CA3AF" strokeWidth="2" markerEnd="url(#arw)" />

        {/* ═══ EARN → TRADE ("sells", green) ═══ */}
        <line x1="402" y1="148" x2="568" y2="258" stroke="#3ba236" strokeWidth="2" markerEnd="url(#arw-g)" />
        <text x="520" y="195" fill="#3ba236" fontSize="13" fontStyle="italic" fontFamily="ui-monospace, monospace">sells</text>

        {/* ═══ BUY → TRADE ("buys", brown) ═══ */}
        <line x1="402" y1="418" x2="568" y2="302" stroke="#a6533a" strokeWidth="2" markerEnd="url(#arw-b)" />
        <text x="505" y="385" fill="#a6533a" fontSize="13" fontStyle="italic" fontFamily="ui-monospace, monospace">buys</text>

        {/* ══════════════════════════════════════════ */}
        {/* EARN node — top center */}
        {/* ══════════════════════════════════════════ */}
        <circle cx="360" cy="120" r="42" fill="white" stroke="#374151" strokeWidth="1.8" />
        <g transform="translate(360, 115)">
          <circle cx="0" cy="-8" r="6" stroke="#374151" fill="none" strokeWidth="1.5" />
          <path d="M-11 10 C-11 2 -6 -2 0 -2 C6 -2 11 2 11 10" stroke="#374151" fill="none" strokeWidth="1.5" />
        </g>
        <text x="295" y="88" textAnchor="end" fill="#1a1a1a" fontSize="16" fontWeight="800" fontFamily="ui-sans-serif, system-ui, sans-serif" letterSpacing="0.05em">EARN</text>
        {/* Description tucked under label, above all arrows */}
        <text x="295" y="108" textAnchor="end" fill="#4B5563" fontSize="11" fontFamily="ui-sans-serif, system-ui, sans-serif">Beat your target,</text>
        <text x="295" y="122" textAnchor="end" fill="#4B5563" fontSize="11" fontFamily="ui-sans-serif, system-ui, sans-serif">BEE issues CCCs to you</text>

        {/* ══════════════════════════════════════════ */}
        {/* MEASURE node — left */}
        {/* ══════════════════════════════════════════ */}
        <circle cx="120" cy="300" r="42" fill="white" stroke="#374151" strokeWidth="1.8" />
        <g transform="translate(120, 300)">
          <path d="M-16 6 Q-8 -12 0 0 Q8 12 16 -6" stroke="#374151" fill="none" strokeWidth="2" strokeLinecap="round" />
        </g>
        <text x="120" y="362" textAnchor="middle" fill="#1a1a1a" fontSize="16" fontWeight="800" fontFamily="ui-sans-serif, system-ui, sans-serif" letterSpacing="0.05em">MEASURE</text>
        <text x="120" y="380" textAnchor="middle" fill="#4B5563" fontSize="11" fontFamily="ui-sans-serif, system-ui, sans-serif">Verify emissions vs</text>
        <text x="120" y="394" textAnchor="middle" fill="#4B5563" fontSize="11" fontFamily="ui-sans-serif, system-ui, sans-serif">your intensity target</text>

        {/* ══════════════════════════════════════════ */}
        {/* BUY node — bottom center */}
        {/* ══════════════════════════════════════════ */}
        <circle cx="360" cy="440" r="42" fill="white" stroke="#374151" strokeWidth="1.8" />
        <g transform="translate(360, 440)">
          <rect x="-9" y="-12" width="18" height="22" rx="2" stroke="#374151" fill="none" strokeWidth="1.5" />
          <rect x="-4" y="-15" width="8" height="5" rx="1" stroke="#374151" fill="none" strokeWidth="1.2" />
          <line x1="-4" y1="-1" x2="4" y2="-1" stroke="#374151" strokeWidth="1.2" />
          <line x1="-4" y1="4" x2="4" y2="4" stroke="#374151" strokeWidth="1.2" />
        </g>
        <text x="300" y="425" textAnchor="end" fill="#1a1a1a" fontSize="16" fontWeight="800" fontFamily="ui-sans-serif, system-ui, sans-serif" letterSpacing="0.05em">BUY</text>
        <text x="300" y="445" textAnchor="end" fill="#4B5563" fontSize="11" fontFamily="ui-sans-serif, system-ui, sans-serif">Miss your target, buy and</text>
        <text x="300" y="459" textAnchor="end" fill="#4B5563" fontSize="11" fontFamily="ui-sans-serif, system-ui, sans-serif">surrender CCCs to cover the gap</text>

        {/* ══════════════════════════════════════════ */}
        {/* TRADE node — center right */}
        {/* ══════════════════════════════════════════ */}
        <circle cx="610" cy="280" r="42" fill="white" stroke="#374151" strokeWidth="1.8" />
        <g transform="translate(610, 280)">
          <path d="M-12 -5 L10 -5 M6 -9 L10 -5 L6 -1" stroke="#374151" fill="none" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
          <path d="M12 5 L-10 5 M-6 1 L-10 5 L-6 9" stroke="#374151" fill="none" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
        </g>
        <text x="610" y="228" textAnchor="middle" fill="#1a1a1a" fontSize="16" fontWeight="800" fontFamily="ui-sans-serif, system-ui, sans-serif" letterSpacing="0.05em">TRADE</text>
        {/* Description BELOW circle */}
        <text x="610" y="342" textAnchor="middle" fill="#4B5563" fontSize="11" fontFamily="ui-sans-serif, system-ui, sans-serif">CCCs bought and sold on</text>
        <text x="610" y="356" textAnchor="middle" fill="#4B5563" fontSize="11" fontFamily="ui-sans-serif, system-ui, sans-serif">CERC-regulated power exchanges</text>

        {/* ══════════════════════════════════════════ */}
        {/* BANK node — far right */}
        {/* ══════════════════════════════════════════ */}
        <circle cx="860" cy="280" r="42" fill="white" stroke="#374151" strokeWidth="1.8" />
        <g transform="translate(860, 280)">
          <path d="M-14 12 L-14 -2 L0 -12 L14 -2 L14 12" stroke="#374151" fill="none" strokeWidth="1.5" strokeLinejoin="round" />
          <line x1="-14" y1="12" x2="14" y2="12" stroke="#374151" strokeWidth="1.5" />
          <line x1="-7" y1="12" x2="-7" y2="1" stroke="#374151" strokeWidth="1.5" />
          <line x1="0" y1="12" x2="0" y2="1" stroke="#374151" strokeWidth="1.5" />
          <line x1="7" y1="12" x2="7" y2="1" stroke="#374151" strokeWidth="1.5" />
        </g>
        <text x="860" y="342" textAnchor="middle" fill="#1a1a1a" fontSize="16" fontWeight="800" fontFamily="ui-sans-serif, system-ui, sans-serif" letterSpacing="0.05em">BANK</text>
        {/* Description BELOW circle */}
        <text x="860" y="360" textAnchor="middle" fill="#4B5563" fontSize="11" fontFamily="ui-sans-serif, system-ui, sans-serif">Surplus CCCs banked</text>
        <text x="860" y="374" textAnchor="middle" fill="#4B5563" fontSize="11" fontFamily="ui-sans-serif, system-ui, sans-serif">for future compliance years</text>
        <text x="860" y="388" textAnchor="middle" fill="#9CA3AF" fontSize="10" fontFamily="ui-sans-serif, system-ui, sans-serif">(no borrowing against future allocations)</text>

        {/* ══════════════════════════════════════════ */}
        {/* VOLUNTARY section */}
        {/* ══════════════════════════════════════════ */}
        <line x1="40" y1="500" x2="960" y2="500" stroke="#9CA3AF" strokeWidth="1.5" strokeDasharray="10 6" />

        <circle cx="200" cy="555" r="35" fill="white" stroke="#3ba236" strokeWidth="1.5" strokeDasharray="8 4" />
        <g transform="translate(200, 555)">
          <path d="M0 -10 C10 -10 12 0 10 6 C8 10 4 12 0 12 C-4 12 -8 10 -10 6 C-12 0 -10 -10 0 -10 Z" stroke="#3ba236" fill="none" strokeWidth="1.3" />
          <path d="M0 -6 C0 0 -2 6 -4 10" stroke="#3ba236" fill="none" strokeWidth="1" />
        </g>
        <text x="200" y="500" textAnchor="middle" fill="#1a1a1a" fontSize="14" fontWeight="800" fontFamily="ui-sans-serif, system-ui, sans-serif" letterSpacing="0.05em">VOLUNTARY</text>
        <text x="260" y="548" textAnchor="start" fill="#4B5563" fontSize="11" fontFamily="ui-sans-serif, system-ui, sans-serif">Non-obligated entities register</text>
        <text x="260" y="562" textAnchor="start" fill="#4B5563" fontSize="11" fontFamily="ui-sans-serif, system-ui, sans-serif">emission-reduction projects</text>
        <text x="260" y="576" textAnchor="start" fill="#4B5563" fontSize="11" fontFamily="ui-sans-serif, system-ui, sans-serif">and earn offset CCCs</text>

        {/* Offset credits note */}
        <rect x="600" y="525" width="340" height="48" rx="6" fill="none" stroke="#9CA3AF" strokeWidth="1" strokeDasharray="6 4" />
        <text x="770" y="545" textAnchor="middle" fill="#9CA3AF" fontSize="10" fontStyle="italic" fontFamily="ui-sans-serif, system-ui, sans-serif">Offset credits are currently for voluntary buyers</text>
        <text x="770" y="560" textAnchor="middle" fill="#9CA3AF" fontSize="10" fontStyle="italic" fontFamily="ui-sans-serif, system-ui, sans-serif">only, not usable to cover a compliance shortfall.</text>

        {/* ═══ Footer ═══ */}
        <line x1="40" y1="608" x2="960" y2="608" stroke="#E5E7EB" strokeWidth="1" />
        <text x="500" y="635" textAnchor="middle" fill="#6B7280" fontSize="11" fontFamily="ui-monospace, monospace" letterSpacing="0.08em">
          BANKED CCCs CAN BE SOLD LATER OR USED FOR YOUR OWN FUTURE COMPLIANCE
        </text>
      </svg>
    </motion.div>
  );
};
